<template>
  <transition name="modalbg">
    <div @click.self="closeModal" class="modal_container">
      <transition name="modal" v-on:before-leave="modalClose">
        <div v-if="showed" class="modal">
          <div class="caption">
            <div class="title-modal">{{textContent.titleAdd}}</div>
            <div @click="closeModal" class="close"></div>
          </div>
          <div class="modal-scroll" :class="{ 'in-last-tab' : isLastTab }">
            <div class="modal-content">
              <form v-on:submit.prevent="addItem">
                <form-input name="title"></form-input>
                <form-drop-down title="title" name="author_id" :id="parentId.authors"
                                :url="apiUrls.content"></form-drop-down>
                <div class="checkbox-group">
                  <checkbox name="show_author"></checkbox>
                  <checkbox name="show_date"></checkbox>
                  <checkbox name="show_in_timetable"></checkbox>
                  <div class="checkbox">
                    <v-checkbox v-model="free" label="Бесплатный семинар"></v-checkbox>
                  </div>
                </div>
                <form-drop-down title="title" name="parent_id" :id="parentId.seminars"
                                :url="apiUrls.content"></form-drop-down>
                <calendar name="date_start"/>
                <!-- <calendar name="date_end" min="date_start"/> -->
                <form-file use-case="cover" name="img"></form-file>
                <form-input name="seo_alt"></form-input>
                <form-input name="video_url"></form-input>
                <form-text-area name="subtext"></form-text-area>
                <form-text-editor name="text" editor-id="editor"></form-text-editor>
                <form-input name="seo_title"></form-input>
                <form-text-area name="seo_key"></form-text-area>
                <form-text-area name="seo_desc"></form-text-area>
              </form>
            </div>
          </div>
          <div class="buttons">
            <div class="next">
              <button @click="closeModal" class="cancel">{{textContent.cancelButton}}</button>
              <button class="confirm" @click="onAddItem">{{textContent.submitButton}}</button>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
  import IconAlignleft from '@/components/icons/IconAlignleft'
  import IconSignalbars from '@/components/icons/IconSignalbars'
  import IconArrowbold from '@/components/icons/IconArrowbold'
  import FormInput from '@/components/create-form/Input'
  import FormTextArea from '@/components/create-form/TextArea'
  import Calendar from '@/components/create-form/Calendar'
  import FormFile from '@/components/create-form/File'
  import FormDropDown from '@/components/create-form/DropDown'
  import FormTextEditor from '@/components/create-form/TextEditor'
  import {createNamespacedHelpers} from 'vuex'
  import Tabs from '@/components/create-form/Tabs'
  import Checkbox from '@/components/create-form/Checkbox'

  const {mapMutations, mapActions, mapState, mapGetters} = createNamespacedHelpers('mainPage')

  export default {
    data () {
      return {
        showed: false,
        free: false
      }
    },
    watch: {
      free (val) {
        let content_id
        val ? content_id = this.parentId.seminarsFree : content_id = this.parentId.seminars
        this.setField({fieldId: 'content_id', fieldPropertyId: 'value', value: content_id})
      }
    },
    computed: {
      ...mapState([
        'textContent',
        'fields'
      ]),
      ...mapGetters([
        'getDataFromEditor',
        'isLastTab'
      ]),
      apiUrls () {
        return this.$store.state.apiUrls
      },
      parentId () {
        return this.$store.state.parentId
      }
    },
    methods: {
      ...mapActions([
        'modalClose',
        'addItem',
        'initFields',
        'onNext',
        'onPrev',
        'checkTabAwailability',
        'addToNews'
      ]),
      ...mapMutations([
        'setField',
        'resetTextEditor',
        'setTabs',
        'setCurrentTabId',
        'setFileExtensions'
      ]),
      getPath () {
        if (this.free) {
          return 'kruglyj-stol' //besplatnye-seminary
        } else {
          return 'seminars'
        }
      },
      onAddItem () {
        this.setField({fieldId: 'text', fieldPropertyId: 'value', value: this.fields.text.editor.getData()})
        this.addItem()
        this.addToNews({
          title: this.fields.title.value,
          url: {
            path: this.getPath(),
            categoryId: null
          },
          img: this.fields.img.value,
          subtext: this.fields.subtext.value
        })
      },
      closeModal () {
        this.showed = false
      }
    },
    mounted () {
      this.showed = true
    },
    created () {
      this.setCurrentTabId(0)
      this.setFileExtensions({img: ['jpg', 'jpeg', 'png', 'gif']})
      this.initFields({
        title: {
          value: '',
          parameterName: 'title',
          name: 'Название семинара',
          errorId: null,
          errors: {empty: 'Введите название семинара'},
          tabId: 0
        },
        author_id: {
          value: '',
          parameterName: 'author_id',
          name: 'Автор',
          errorId: null,
          errors: {empty: 'Выберите автора'},
          tabId: 0,
          isNullable: true
        },
        parent_id: {
          value: '',
          parameterName: 'parent_id',
          name: 'Категория',
          errorId: null,
          errors: {empty: 'Выберите категорию'},
          tabId: 0,
        },
        date_start: {
          value: '',
          parameterName: 'date_start',
          name: 'Дата начала',
          errorId: null,
          errors: {empty: 'Выберите дату начала семинара'},
          tabId: 0
        },
        // date_end: {
        //   value: '',
        //   parameterName: 'date_end',
        //   name: 'Дата окончания',
        //   errorId: null,
        //   errors: {empty: 'Выберите дату окончания семинара'},
        //   tabId: 0
        // },
        show_in_timetable: {
          value: true,
          parameterName: 'show_in_timetable',
          type: 'object',
          name: 'Отображать в расписании',
          isNullable: true,
          errorId: null,
          tabId: 0
        },
        video_url: {
          value: '',
          parameterName: 'video_url',
          type: 'object',
          name: 'Ссылка на видео',
          isNullable: true,
          errorId: null,
          errors: {empty: 'Выберите дату окончания семинара'},
          tabId: 0
        },
        show_author: {
          value: true,
          parameterName: 'show_author',
          name: 'Отображать автора',
          errorId: null,
          tabId: 0,
          isNullable: true
        },
        show_date: {
          value: true,
          parameterName: 'show_date',
          name: 'Отображать дату',
          errorId: null,
          tabId: 0,
          isNullable: true
        },
        img: {
          value: '',
          parameterName: 'img',
          name: 'Изображение',
          errorId: null,
          errors: {empty: 'Выберите изображение', extension: 'Допустимые расширения: jpg, jpeg, png, gif'},
          fileName: '',
          tabId: 0
        },
        subtext: {
          value: '',
          parameterName: 'subtext',
          name: 'Краткое описание',
          errorId: null,
          errors: {empty: 'Введите краткое описание'},
          tabId: 0,
        },
        seo_alt: {
          value: '',
          parameterName: 'seo_alt',
          name: 'Альтернативный текст',
          errorId: null,
          isNullable: true,
          errors: {empty: 'Введите альтернативный текст'},
          tabId: 0
        },
        text: {
          value: '',
          parameterName: 'text',
          name: 'Текст',
          errorId: null,
          errors: {empty: 'Введите текст'},
          tabId: 0,
        },
        seo_title: {
          value: '',
          parameterName: 'seo_title',
          name: 'Название страницы',
          errorId: null,
          errors: {empty: 'Напишите название страницы'},
          tabId: 0
        },
        seo_key: {
          value: '',
          parameterName: 'seo_key',
          name: 'Ключевые слова',
          errorId: null,
          errors: {empty: 'Напишите ключевые слова'},
          tabId: 0,
          isNullable: true
        },
        seo_desc: {
          value: '',
          parameterName: 'seo_desc',
          name: 'Краткое описание',
          errorId: null,
          errors: {empty: 'Напишите краткое описание'},
          tabId: 0
        },
        content_id: {
          value: this.$store.state.parentId.seminars,
          parameterName: 'content_id',
          errorId: null,
          isNullable: true,
        },
        object: {
          value: {},
          parameterName: 'object',
          errorId: null,
          isNullable: true,
        }
      })
    },
    components: {
      Checkbox,
      IconAlignleft,
      IconSignalbars,
      IconArrowbold,
      FormInput,
      FormTextArea,
      FormFile,
      FormDropDown,
      FormTextEditor,
      Tabs,
      Calendar
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/pages/kruglyj-stol/articles/CreateModal.vue